import { render, staticRenderFns } from "./ShareModal.vue?vue&type=template&id=2fd88581&scoped=true&"
import script from "./ShareModal.vue?vue&type=script&lang=js&"
export * from "./ShareModal.vue?vue&type=script&lang=js&"
import style0 from "./ShareModal.vue?vue&type=style&index=0&id=2fd88581&scoped=true&lang=scss&"
import style1 from "./ShareModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd88581",
  null
  
)

export default component.exports